import React from "react";
import json_members from "./Members.json";
import { useFetch, loading } from "../../helpers/hooks.jsx";
import "./members.css";

const Members = ({ lang }) => {
  const [members, loadingMembers] = useFetch("https://sancta-cecilia.cz/members_json.php");

  return (
    <div className="members">
      <div className="membersTitle">{json_members[lang]}</div>
      <div className="membersItems">
        {loadingMembers
          ? loading[lang]
          : members.map((member, index) => (
              <div key={index} className="memberItem">
                <div className="memberName">{member["jmeno"]}</div>
                <div className="memberInstruments">{member["nastroje_" + lang.substr(0, 2)]}</div>
              </div>
            ))}
      </div>
    </div>
  );
};

export default Members;



// WEBPACK FOOTER //
// ./src/components/About/Members.jsx